module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmh1"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "fmh2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("by Ralph Percy, 12th Duke of Northumberland")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I was brought up on tales of Hotspur’s bravery, heroism, and chivalry without questioning his heady reputation, gained on fields of battle and in corridors of power. Historians, poets, and playwrights have been generous to Harry Percy, imbuing him with legendary charisma and popularity, and Shakespeare has perpetuated this shining reputation for nobility despite Hotspur’s many flaws. John Sadler takes a deeper and more critical look at Hotspur’s character, and the flow of events that created his legend and ultimately led to disaster. It shows other, less attractive characteristics; petulance, arrogance, bullying, cruelty, and overwhelming ambition, a trait shared with his father, the 1st Earl of Northumberland, that raised the Percies to dizzying heights and precipitated a disastrous fall. This book also seeks to make sense of historical events, questioning previous assertions that were often based on scant knowledge and repeated as gospel over generations. It takes a fresh, forensic look at one of the most fascinating and bloody periods in our history, a history that could have been very different but for the flight of a single, deadly arrow.")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ralph Northumberland")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("January 2022")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e812272","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Foreword.vue
// module id = 72
// module chunks = 0